<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="book-subtitle" lang="en-US"><span class="CharOverride-3">Ron Carlson Writes a Story</span></p>
<p class="book-subtitle" lang="en-US">Tips from a Master of the Craft</p>
<p class="book-author_print-only" lang="en-US"><span class="CharOverride-4">Ron Carlson</span></p>
<p class="book-author_print-only" lang="en-US"><img src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RonCarlson-24.vue?13290645